import {
    Component,
    effect,
    HostListener,
    inject,
    input,
    model,
    signal,
    output,
    viewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { SearchService } from 'src/app/services/search.service';
import { UserService, User } from 'src/app/services/userService';
import { LoadingService } from '../../loading.service';
import { ShortcutsService } from 'src/app/services/utility/shortcuts.service';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    FormBlueprint,
    ListInput,
    ListItem,
    TextInput,
} from '../ui/form/formTypes';
import { MutationInput } from 'src/app/api/graphql/mutation-input';
import { MutationDialogComponent } from '../ui/mutation-dialog/mutation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Column, TextElement } from '../ui/table/column';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatToolbar,
        MatButtonModule,
        MatIcon,
        MatMenuModule,
        FormsModule,
        MatSlideToggle,
        MatTooltip,
        CommonModule,
    ],
})
export class ToolbarComponent {
    readonly toolbarEvent = output<any>();
    readonly shortcutInput = viewChild(MatInput);
    sidenavToggle = model.required<boolean>();
    darkMode = signal<boolean>(false);
    setDarkMode = effect(() => {
        localStorage.setItem('darkMode', this.darkMode() ? 'true' : 'false');
        document.documentElement.classList.toggle('dark', this.darkMode());
    });
    public user;
    showShortcutInput: boolean = false;
    shortcut?: string;
    shortcutsService = inject(ShortcutsService);
    snackbar = inject(MatSnackBar);
    dialog = inject(MatDialog);
    @HostListener('document:keypress', ['$event'])
    public handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key == '\x1C') this.showShortcutInput = true;
        this.shortcutInput()?.focus();
    }
    constructor(
        private search: SearchService,
        private authService: UserService,
        public loadingService: LoadingService,
    ) {
        this.user = this.authService.user;
        if (localStorage.getItem('darkMode')) {
            this.darkMode.set(localStorage.getItem('darkMode') === 'true');
        }
    }

    onMenu() {
        this.sidenavToggle.update((s) => !s);
    }

    DoShortcut(event: KeyboardEvent) {
        if (event.key == 'Enter') {
            if (!this.shortcutsService.handelShortCut(this.shortcut)) {
                this.snackbar.open('No shortcut Found :(', 'close', {
                    duration: 1000,
                });
                return;
            }
            this.shortcut = '';
            this.showShortcutInput = false;
        }
    }

    signOut(): void {
        this.authService.signOut();
    }

    openShortCuts = () => {
        const editShortcuts = new MutationInput(this.SHORTCUT_EDITOR);
        this.dialog.open(MutationDialogComponent, {
            data: {
                mutationInput: editShortcuts,
                title: 'Edit Shortcuts',
            },
        });
    };
    SHORTCUT_EDITOR: FormBlueprint = new FormBlueprint(
        [
            {
                input: new ListInput(
                    {},
                    () =>
                        Object.entries(this.shortcutsService.shortcuts).map(
                            (shortcut) => {
                                return {
                                    data: {
                                        ...shortcut[1],
                                        command: shortcut[0],
                                    },
                                    itemActions: () => [
                                        {
                                            name: 'Remove',
                                            action: (input: any) => {
                                                let shortcut = {
                                                    ...this.shortcutsService
                                                        .shortcuts,
                                                };
                                                delete shortcut[input.command];
                                                localStorage.setItem(
                                                    'shortcuts',
                                                    JSON.stringify(shortcut),
                                                );
                                            },
                                        },
                                    ],
                                } as ListItem;
                            },
                        ),
                    SHORTCUT_COLUMNS,
                    this.shortcutsService.addItem,
                ),
                field: {
                    key: 'list',
                    value: (test: any) => {
                        return { test: 'test' };
                    },
                },
            },
        ],
        { noCancelConfirm: true },
    );
}
const SHORTCUT_COLUMNS: Column[] = [
    {
        key: 'command',
        label: 'Command',
        columnElements: [
            new TextElement({
                key: 'command',
            }),
        ],
    },
    {
        key: 'type',
        label: 'ActionType',
        columnElements: [
            new TextElement({
                key: 'type',
            }),
        ],
    },
    {
        key: 'action',
        label: 'Action',
        columnElements: [
            new TextElement({
                key: 'action',
            }),
        ],
    },
];
